module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter TableOfContents",
    attrs: {
      "id": "rw-frontmatter-TableOfContents_41840-00001"
    }
  }, [_c('div', {
    staticClass: "media image align-center"
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Cover Image",
      "src": "welcome_image_online.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "block toc",
    attrs: {
      "id": "rw-block-toc_41840-00001"
    }
  }, [_c('div', {
    staticClass: "block list-toc",
    attrs: {
      "id": "rw-block-list-toc_41840-00001"
    }
  }, [_c('div', [_c('p', {
    staticClass: "toc-bm",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "href": "#/9780316187466_chapter_01#rw-title-block_41832-00001"
    }
  }, [_vm._v("Begin Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "toc-title"
  }, [_c('span', {
    attrs: {
      "href": "#/9780316187466_abouttheauthor#rw-title-block_41833-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meet the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "toc-title"
  }, [_c('span', {
    attrs: {
      "href": "#/9780316187466_teaser#rw-title-block_41836-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonus Material")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "toc-title"
  }, [_c('span', {
    attrs: {
      "href": "#/9780316187466_allpurpose#rw-title-block_41837-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Orbit Short Fiction")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3c27c7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780316187466_tableofcontents.vue
// module id = 63
// module chunks = 0